import classNames from 'classnames';
import { lessAgressiveColorMapper } from 'components/PostTrade/ProductModification/components/ValidationErrors.utils';
import { ConnectedBidAsk } from 'components/secondaryMarket/shared/SidePanel/BidAsk';
import { ConnectedDlpRealtimeFooter } from 'components/secondaryMarket/shared/SidePanel/DlpRealtimeFooter.connect';
import { ActionButton, ButtonPanel, MessagesPanel } from 'components/secondaryMarket/shared/status';
import { PanelFooter, PanelHeader } from 'components/secondaryMarket/shared/status/Panel';
import { useMemo } from 'react';
import type { DlpOrderFormModel } from 'state/secondaryMarket/dlpOrder/form/dlpOrderForm.model';

import type { NotReadySidePanelProps } from './NotReadySidePanel.connect';

export function NotReadySidePanel({ validationErrors, backendReports, className, tabId }: NotReadySidePanelProps) {
  const errors = useMemo(() => [...validationErrors, ...backendReports], [validationErrors, backendReports]);
  return (
    <div className={classNames('d-flex flex-column overflow-y-auto', className)}>
      <PanelHeader textColor="secondary" color="lvl1" discreet className="border border-bottom-0 p-0">
        <ConnectedBidAsk tabId={tabId} />
      </PanelHeader>
      <PanelFooter
        textColor="secondary"
        color="lvl1"
        className="border"
        statusKey="secondaryMarket.sidePanel.label.notReady"
        discreet
        icon="not_ready"
      >
        <ConnectedDlpRealtimeFooter className="flex-grow-1" tabId={tabId} />
      </PanelFooter>
      <MessagesPanel<DlpOrderFormModel>
        errors={errors}
        className="flex-grow-1 pt-2"
        e2e="side-panel-header"
        colorToSeverity={lessAgressiveColorMapper}
      ></MessagesPanel>
      <ButtonPanel>
        <ActionButton color="primary" label="secondaryMarket.sidePanel.label.placeOrder" disabled />
      </ButtonPanel>
    </div>
  );
}

NotReadySidePanel.displayName = 'NotReadySidePanel';
